import { render } from "./RecipientsTable.vue?vue&type=template&id=9b69f9e6"
import script from "./RecipientsTable.vue?vue&type=script&lang=js"
export * from "./RecipientsTable.vue?vue&type=script&lang=js"

import "./RecipientsTable.vue?vue&type=style&index=0&id=9b69f9e6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__